
// store.js
import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Import the storage engine

import {
  allUsersReducer,
  forgotPasswordReducer,
  profileReducer,
  userDetailsReducer,
  userReducer,
  createJobReducer,
  cvsUploadedReducer,
  addCandidateReducer,
  allCandidatesOfJobReducer,
  allCustomersOfCorpReducer,
  logoReducer,
  notificationsReducer,
  getTeamMembersReducer
} from "./reducers/userReducer";

import {
  allOrdersReducer,
  myOrdersReducer,
  newOrderReducer,
  orderDetailsReducer,
  orderReducer,
  creditsCountReducer,
} from "./reducers/orderReducer";
import {
  candidateReducer,
  canidateUserReducer,
} from "./reducers/candidateReducer";

import { languageReducer } from "./reducers/userReducer";

import { candidateLanguageReducer } from "./reducers/candidateReducer";
import { logout } from "./actions/userAction";

const rootReducer = combineReducers({
  user: userReducer,
  profile: profileReducer,
  forgotPassword: forgotPasswordReducer,
  allUsers: allUsersReducer,
  userDetails: userDetailsReducer,
  createJob: createJobReducer,
  cvsUploaded: cvsUploadedReducer,
  addCandidate: addCandidateReducer,
  allCandidatesOfJob: allCandidatesOfJobReducer,
  allOrders: allOrdersReducer,
  myOrders: myOrdersReducer,
  newOrder: newOrderReducer,
  orderDetails: orderDetailsReducer,
  order: orderReducer,
  creditsCount: creditsCountReducer,
  candidate: candidateReducer,
  candidateUser: canidateUserReducer,
  language: languageReducer,
  allCustomers: allCustomersOfCorpReducer,
  candidateLanguage: candidateLanguageReducer,
  logo: logoReducer,
  notifications: notificationsReducer,
  getTeamMembers: getTeamMembersReducer
});

const persistConfig = {
  key: 'persistedData',
  storage,
  // PERF: Whitelist only small, essential slices. Without this, ALL 22 reducers
  // (~33MB including allCandidatesOfJob, allCustomers, notifications, createJob)
  // were serialized to localStorage via JSON.stringify on EVERY Redux dispatch.
  whitelist: ['user', 'candidateUser', 'language', 'candidateLanguage', 'logo', 'creditsCount'],
  version: 1,
  migrate: (state) => {
    // Purge old cache from version 0 (no whitelist) to version 1 (with whitelist)
    if (!state || state._persist?.version !== 1) return Promise.resolve(undefined);
    return Promise.resolve(state);
  },
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        ignoredActionPaths: ['register', 'rehydrate'],
      },
    }).concat(thunk),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);
export default store;

